import React from 'react'

import { observer } from 'mobx-react'

const Combinator = observer(({ data }) => (
    <div className="ff-combinator">
        <div className="ff-combinator__title">
            <i className="fal fa-code-merge" />
            <span>How the user gate joins the tag set below</span>
        </div>
        <div className="ff-combinator__cards">
            <div
                className={`ff-combinator__card ${data.combinator === 'AND' ? 'is-selected' : ''}`}
                onClick={() => data.combinator = 'AND'}
            >
                <div className="ff-combinator__card-head">
                    <i className={data.combinator === 'AND' ? 'fa-solid fa-circle-check' : ' fal fa-circle'} />
                    <div className="ff-combinator__card-label">AND</div>
                    <div className="ff-combinator__card-use">— for locking</div>
                </div>
                <p>Both sides must pass. The user gate becomes a hard requirement — no tag can grant an exception.</p>
            </div>
            <div
                className={`ff-combinator__card ${data.combinator === 'OR' ? 'is-selected' : ''}`}
                onClick={() => data.combinator = 'OR'}
            >
                <div className="ff-combinator__card-head">
                    <i className={data.combinator === 'OR' ? 'fa-solid fa-circle-check' : ' fal fa-circle'} />
                    <div className="ff-combinator__card-label">OR</div>
                    <div className="ff-combinator__card-use">— for exceptions</div>
                </div>
                <p>Either side can pass. The tag set lets in people and surveys that the user gate excludes.</p>
            </div>
        </div>
    </div>
))

export default Combinator
